<template>
  <ODialog ref="dialog" :maxWidth="700">
    <OLoading :value="row == null" />

    <v-card v-if="row != null">
      <v-toolbar class="card-bar">
        <v-toolbar-title>
          Account
          <small class="grey--text text--lighten-1"> #{{ row.id }} </small>
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$refs.dialog.$dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-3">
        <div class="h-row-wrap children-pa-3">
          <div class="cap-cont oderon-col-12">
            <label>Nome</label>
            <p>{{ row.fullName }}</p>
          </div>

          <div class="cap-cont oderon-col-12">
            <label>Email</label>
            <p>{{ row.email }}</p>
          </div>

          <div class="cap-cont oderon-col-12">
            <label>URL padrão</label>
            <p>{{ row.nextUrl || '-'}}</p>
          </div>

          <div class="cap-cont oderon-col-6">
            <label>Apps permitidas</label>
            <div class="tag-list">
              <span v-for="t in row.apps" :key="t" class="tag grey">{{
                t
              }}</span>
            </div>
          </div>

          <div class="cap-cont oderon-col-6">
            <label>Tags</label>
            <div class="tag-list">
              <span v-for="t in row.tags" :key="t" class="tag grey">{{
                t
              }}</span>
            </div>
          </div>

          <div class="cap-cont oderon-col-6">
            <label>Criado em</label>
            <p>{{ row.createdAt | brLongDateTime }}</p>
          </div>
          <div class="cap-cont oderon-col-6">
            <label>Atualizado em</label>
            <p>{{ row.updatedAt | brLongDateTime }}</p>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pa-6">
        <v-spacer />
        <OHoldToConfirm color="error" @confirmed="emitDelete">
          Apagar...
        </OHoldToConfirm>
      </v-card-actions>
    </v-card>
  </ODialog>
</template>

<script>
import { Account } from '@/models'

export default {
  mixins: [require('oderon-vue/cpts/dialog-promise-mixin').default],
  components: {
    OLoading: require('oderon-vue/cpts/OLoading').default,
    ODialog: require('oderon-vue/cpts/ODialog').default,
    OHoldToConfirm: require('oderon-vue/cpts/OHoldToConfirm').default
  },
  data() {
    return this.reset()
  },
  methods: {
    reset() {
      return {
        code: null,
        row: null
      }
    },

    async open(id) {
      Object.assign(this, this.reset())
      this.id = id
      this.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      this.row = await Account.findById(this.id)
    },

    emitDelete() {
      this.$refs.dialog.$apply('DELETE')
    }
  }
}
</script>

<style>
.scroll-x {
  overflow-x: auto;
  white-space: pre-wrap;
}
</style>
